import React from 'react';
import { useGetPermissions } from 'layouts/customHook';
import { PermisionDenied } from 'views/pages/manage/common/commonComponents';
import CashControlConfigPage from './CashControlConfigPage';

const CashControlConfigSetup = () => {
    const userPermissions = useGetPermissions('cashControlConfig');
    return (
        userPermissions ? <CashControlConfigPage  userPermissions={userPermissions}/> : <PermisionDenied />
    )
}

export default CashControlConfigSetup